export const GLOBAL_ROLE_HIERARCHY = ['reader', 'author', 'editor', 'admin', 'owner'];
export const ROLE_LABELS = {
    reader: 'Reader',
    author: 'Author',
    editor: 'Editor',
    admin: 'Admin',
    owner: 'Owner',
};
export function hasGlobalRole(userRoles, role) {
    if (!userRoles?.length)
        return false;
    return userRoles.includes(role);
}
export function canAccessStudio(userRoles) {
    return Boolean(userRoles?.some((role) => role === 'admin' || role === 'owner'));
}
export function canAccessAdmin(userRoles) {
    return Boolean(userRoles?.some((role) => role === 'admin' || role === 'owner'));
}
export function mergeRoles(...roleGroups) {
    const flat = roleGroups.flatMap((roles) => roles ?? []);
    const unique = Array.from(new Set(flat));
    return GLOBAL_ROLE_HIERARCHY.filter((role) => unique.includes(role));
}
export function getPrimaryRole(roles) {
    const merged = mergeRoles(roles);
    return [...merged].sort((a, b) => GLOBAL_ROLE_HIERARCHY.indexOf(b) - GLOBAL_ROLE_HIERARCHY.indexOf(a))[0] ?? 'reader';
}
